import {Typography} from '@mui/material';

export default function FooterAbout() {
  return (
    <>
      <Typography variant="h6" color="text.primary" gutterBottom>
        About Us
      </Typography>
      <Typography variant="body2" color="text.secondary">
        We&apos;re dedicated to helping Etsy sellers succeed with powerful, easy-to-use tools.
      </Typography>
    </>
  );
}
